import styled from "styled-components";

const SectionHeading = styled.h2`
  text-align: center;

  text-transform: uppercase;
  text-shadow: 4px 4px 2px rgba(0, 0, 0, 0.2);

  background-image: linear-gradient(98.3deg, rgb(0, 0, 0) 10.6%, #007fff 97.7%);
  -webkit-background-clip: text;
  color: transparent;

  font-family: "Lato", sans-serif;
  font-weight: 600;
  font-size: 3rem;

  margin-bottom: 4rem;
`;

export default SectionHeading;
